// ─── InvoicesPage.jsx ───────────────────────────────────────────────────────
import React, { useEffect, useState, useCallback } from 'react';
import { Box, Typography, Button, InputAdornment, TextField, Chip } from '@mui/material';
import { Search, Download } from '@mui/icons-material';
import { invoicesAPI } from '../services/api';
import DataTable, { StatusChip } from '../components/common/DataTable';
import { toast } from 'react-toastify';

const fmt = (n) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n || 0);

const InvoicesPage = () => {
  const [invoices, setInvoices] = useState([]); const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0); const [page, setPage] = useState(0); const [rowsPerPage, setRowsPerPage] = useState(20);
  const [search, setSearch] = useState('');

  const fetchInvoices = useCallback(async () => {
    try { setLoading(true);
      const { data } = await invoicesAPI.getAll({ page: page+1, limit: rowsPerPage });
      setInvoices(data.data||[]); setTotal(data.pagination?.total||0);
    } catch { toast.error('Failed to load invoices'); } finally { setLoading(false); }
  }, [page, rowsPerPage]);

  useEffect(() => { fetchInvoices(); }, [fetchInvoices]);

  const downloadPDF = async (id, number) => {
    try {
      const { data } = await invoicesAPI.downloadPDF(id);
      const url = URL.createObjectURL(new Blob([data]));
      const a = document.createElement('a'); a.href = url; a.download = `Invoice-${number}.pdf`; a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error('Failed to download PDF'); }
  };

  const columns = [
    { key: 'invoice_number', label: 'Invoice #', render: (v) => <Typography fontFamily="monospace" fontWeight={600} fontSize="0.85rem">{v}</Typography> },
    { key: 'customer_name', label: 'Customer' },
    { key: 'issue_date', label: 'Issue Date', render: (v) => new Date(v).toLocaleDateString() },
    { key: 'due_date', label: 'Due Date', render: (v) => new Date(v).toLocaleDateString() },
    { key: 'total_amount', label: 'Total', align: 'right', render: (v) => <Typography fontWeight={700}>{fmt(v)}</Typography> },
    { key: 'paid_amount', label: 'Paid', align: 'right', render: (v) => fmt(v) },
    { key: 'balance_due', label: 'Due Balance', align: 'right', render: (v) => <Typography color={v > 0 ? 'error.main' : 'success.main'} fontWeight={700}>{fmt(v)}</Typography> },
    { key: 'status', label: 'Status', render: (v) => <StatusChip status={v} /> },
    { key: 'id', label: '', render: (v, row) => (
      <Button size="small" startIcon={<Download />} onClick={() => downloadPDF(v, row.invoice_number)}>PDF</Button>
    )},
  ];

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h4" fontWeight={700}>Invoices</Typography>
      </Box>
      <DataTable columns={columns} rows={invoices} loading={loading} total={total} page={page} rowsPerPage={rowsPerPage}
        onPageChange={(_, p) => setPage(p)} onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value)); setPage(0); }} />
    </Box>
  );
};

export { InvoicesPage };
export default InvoicesPage;
